// ///////////////////////
// MARK: CONFIG
export const DEFAULT_RECT: DOMRectReadOnly = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  toJSON: () => '{}',
}

// ///////////////////////
// MARK: CONTEXT
export type TAppViewStateValue = DOMRectReadOnly & {
  ref?: Element
}

export interface IAppViewState {
  navbar: TAppViewStateValue
  subNavbar: TAppViewStateValue
  breadcrumb: TAppViewStateValue
  quickActions: TAppViewStateValue
  quickActionsAdd: TAppViewStateValue
  bottomBar: TAppViewStateValue
}

export interface IAppViewModel {}

export interface IAppViewFunctions {
  set(key: keyof IAppViewState, value: TAppViewStateValue): void
}

export interface IAppViewContext extends IAppViewState, IAppViewModel, IAppViewFunctions {}

export function getAppViewContext(): IAppViewModel {
  return {}
}

// ///////////////////////
// MARK: CONTEXT FUNCTIONS
export function getAppViewContextFunctions(
  state: IAppViewState,
  setState: React.Dispatch<React.SetStateAction<IAppViewState>>,
): IAppViewFunctions {
  return {
    set(key, value) {
      setState((oldState) => {
        const oldValue = oldState[key]

        if (
          oldValue.top !== value.top ||
          oldValue.bottom !== value.bottom ||
          oldValue.left !== value.left ||
          oldValue.right !== value.right ||
          oldValue.x !== value.x ||
          oldValue.y !== value.y ||
          oldValue.width !== value.width ||
          oldValue.height !== value.height ||
          oldValue.ref !== value.ref
        ) {
          return {
            ...oldState,
            [key]: value,
          }
        }

        return oldState
      })
    },
  }
}

function addVirtualHeight(height: number) {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    x: 0,
    y: 0,
    width: 0,
    height,
    toJSON: () => '{}',
  }
}

// ///////////////////////
// MARK: INITIAL STATE
export function getAppViewInitialState(): IAppViewState {
  return {
    navbar: addVirtualHeight(64),
    subNavbar: addVirtualHeight(48),
    breadcrumb: addVirtualHeight(40),
    quickActions: DEFAULT_RECT,
    quickActionsAdd: DEFAULT_RECT,
    bottomBar: addVirtualHeight(50),
  }
}
